import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex-1 flex flex-col overflow-hidden" }

import { onMounted } from "vue";
import { segmentAnalytics } from "@/assets/scripts";
import NavigationComponent from "@/components/layout/NavigationComponent.vue";
import GalleryContent from "@/views/camera/components/GalleryContent.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Gallery',
  setup(__props) {

onMounted(() => {
  segmentAnalytics("Gallery Visit");
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(NavigationComponent, {
    activeTag: _ctx.$t('app_features.gallery')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(GalleryContent)
      ])
    ]),
    _: 1
  }, 8, ["activeTag"]))
}
}

})